import { useSearchParams } from 'react-router-dom';
import TableUnit from './TableUnit';
import * as C from '../../../ui/common/CommonStyles';
import { Group, Pagination } from '@mantine/core';
import CustomSearch from '../../../ui/search/customSearch';
import { useCustomSearch } from '../../../../shared/hook/useCustomSearch';
import { cleanParams } from '../../../../shared/utils/cleanParams';
import { useDataPointOrderList } from '../hooks/dataPointService';

const options = [
  { value: 'all', label: 'All' },
  { value: 'userId', label: '유저 아이디' },
  { value: 'deviceId', label: '디바이스 번호' },
];

const DataPointPayment = () => {
  const statusCd = 1;
  // 클라이언트단 url parameter 설정
  const [searchParams, setSearchParams] = useSearchParams('');
  const searchWord = searchParams.get('keyword') || '';
  const searchType = searchParams.get('searchType') || 'all';
  const page = searchParams.get('page') || '1';
  const size = searchParams.get('size') || '10';

  const { inputRef, handleSearch, resetWord, handleSearchType, resetSearchInput } = useCustomSearch({
    initType: 'all',
  });

  // 데이터 포인트 결제 리스트 조회 쿼리
  const { data: getDataPointOrderListQuery } = useDataPointOrderList({
    queryKey: ['loadDataPointOrderListQuery', Number(page), searchType, searchWord, statusCd],
    query: {
      searchType,
      searchWord,
      page: Number(page),
      size: Number(size),
      statusCd,
    },
  });

  // 페이지네이션 처리를 위한 토탈값
  const total: number = getDataPointOrderListQuery?.data.count;

  return (
    <div>
      <C.TitleBox>
        <div className="title">결제내역 리스트</div>
      </C.TitleBox>
      <C.ListBox>
        <C.Toolbar>
          <CustomSearch
            resetSearch={resetWord}
            resetSearchInput={resetSearchInput}
            searchType={searchType}
            setSearchType={handleSearchType}
            inputRef={inputRef}
            handleSearch={handleSearch}
            searchOptions={options}
          />
        </C.Toolbar>
        <C.TableWrap>
          <TableUnit data={getDataPointOrderListQuery} />
          {total > 0 ? (
            <Group justify="center" mt="md">
              <Pagination
                total={Math.ceil(total / Number(size))}
                value={Number(page)}
                onChange={(value) => {
                  const currentParams = Object.fromEntries(searchParams.entries());
                  setSearchParams(
                    cleanParams({
                      ...currentParams,
                      page: String(value),
                    }),
                  );
                }}
              />
            </Group>
          ) : null}
        </C.TableWrap>
      </C.ListBox>
    </div>
  );
};

export default DataPointPayment;
